import { render, staticRenderFns } from "./notificacao.vue?vue&type=template&id=561cf075&scoped=true&"
import script from "./notificacao.vue?vue&type=script&lang=js&"
export * from "./notificacao.vue?vue&type=script&lang=js&"
import style0 from "./notificacao.vue?vue&type=style&index=0&id=561cf075&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561cf075",
  null
  
)

export default component.exports